import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable()
export class MyHttpClient {
  public cookies: any;
  public userCookie: any;
  public userIdCookie: any;
  public userId: any;
  private _headers = new HttpHeaders().set('Content-Type', 'application/json');
  constructor(private http: HttpClient) { }

  setHeaderData() {

    //populates data for headers with latest cookies
    this.cookies = document.cookie.split(";");
    if(this.cookies){
      this.userCookie = this.cookies.find(function (item) {
        return item.includes('_id');
      })
    }
    if (this.userCookie) {
      this.userIdCookie = Object.values(JSON.parse(this.userCookie))[0];
    }
    if(this.userIdCookie){
      this.userId = '{"_id":"' + this.userIdCookie + '"}'
    }

  }


  get<T>(url, options = {}) {
    this.setHeaderData();
    const headers = this._headers.append('user', this.userId ? this.userId : '')
      .append('Expires', '0')
      .append('Cache-control', 'no-cache')
      .append('Cache-control', 'no-store')
      .append('Pragma', 'no-cache');

    return this.http.get<T>(url, { headers: headers, ...options });
  }

  post(url, data, config = {}) {
    this.setHeaderData();
    let headers = this._headers.append('user', this.userId ? this.userId : '')
      .append('Expires', '0')
      .append('Cache-control', 'no-cache')
      .append('Cache-control', 'no-store')
      .append('Pragma', 'no-cache');
    const cfg: any = config || {};
    const extra = cfg.headers;
    if (extra) {
      if (typeof (extra as any).keys === 'function') {
        (extra as any).keys().forEach((k: string) => {
          const v = (extra as any).get(k);
          if (v !== null && v !== undefined) {
            headers = headers.set(k, v);
          }
        });
      } else {
        Object.keys(extra).forEach((k: string) => {
          const v: any = (extra as any)[k];
          if (v !== null && v !== undefined) {
            headers = headers.set(k, String(v));
          }
        });
      }
    }
    const finalConfig = { ...config, headers };
    return this.http.post(url, data, finalConfig);
  }

  put(url, data, config = {}) {
    this.setHeaderData();
    let headers = this._headers.append('user', this.userId ? this.userId : '')
      .append('Expires', '0')
      .append('Cache-control', 'no-cache')
      .append('Cache-control', 'no-store')
      .append('Pragma', 'no-cache');
    const cfg: any = config || {};
    const extra = cfg.headers;
    if (extra) {
      if (typeof (extra as any).keys === 'function') {
        (extra as any).keys().forEach((k: string) => {
          const v = (extra as any).get(k);
          if (v !== null && v !== undefined) {
            headers = headers.set(k, v);
          }
        });
      } else {
        Object.keys(extra).forEach((k: string) => {
          const v: any = (extra as any)[k];
          if (v !== null && v !== undefined) {
            headers = headers.set(k, String(v));
          }
        });
      }
    }
    const finalConfig = { ...config, headers };
    return this.http.put(url, data, finalConfig);
  }

  getWithCache<T>(url, options = {}) {
    this.setHeaderData();
    const headers = this._headers.append('user', this.userId ? this.userId : '')
        .append('Cache-control', 'max-age=1200, private');
    return this.http.get<T>(url, { headers: headers, ...options });
  }
}
